module.exports = function() {
  return new Worker(__webpack_public_path__ + "9373abe2f093a9ff3efb.worker.js");
};